import type { AccountDetail } from '../../../api/accounts'
import { formatDateTime } from '../../../lib/format'
import { EnvironmentBadge } from './StatusBadge'

/** What Apple says the account bought: subscriptions and one-time purchases. Read-only: changes come from Apple. */
export function PurchasesCard({ purchases }: { purchases: AccountDetail['purchases'] }) {
	return (
		<section className="card stack">
			<h2 style={{ margin: 0 }}>Purchases</h2>
			{purchases.length ? (
				<div className="table-scroll">
					<table>
						<thead>
							<tr>
								<th>Original transaction</th>
								<th>Product</th>
								<th>Status</th>
								<th>Expires</th>
								<th>Renews</th>
							</tr>
						</thead>
						<tbody>
							{purchases.map((s) => (
								<tr key={s.id}>
									<td className="mono">
										{s.originalTransactionId} <EnvironmentBadge environment={s.environment} />
									</td>
									<td className="small">
										{s.productId}
										{s.type === 'non_consumable' && <span className="muted"> · one-time</span>}
									</td>
									<td>{s.status}</td>
									<td className="small muted">
										{formatDateTime(s.status === 'grace' ? s.graceExpiresAt : s.expiresAt)}
									</td>
									<td className="small muted">{s.autoRenew === null ? '—' : s.autoRenew ? 'yes' : 'no'}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			) : (
				<p className="muted small" style={{ margin: 0 }}>
					None.
				</p>
			)}
		</section>
	)
}
